import './login.css';
import React, { useEffect, useState } from 'react';
import { Translate, translate, ValidatedField, ValidatedForm, Storage } from 'react-jhipster';
import { Alert, Col, DropdownItem, Row } from 'reactstrap';
import { toast } from 'react-toastify';
import { Link, useLocation } from 'react-router-dom';
import Grid from '@material-ui/core/Grid';
import { Box, createTheme, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Theme } from '@mui/material';
import TranslateIcon from '@mui/icons-material/Translate';
import Paper from '@mui/material/Paper';
import { Button as ButtonReact } from 'reactstrap';
import { Button } from '@material-ui/core';
import { isRTL, languages, locales } from 'app/config/translation';
import { setLocale } from 'app/shared/reducers/locale';
import { NavDropdown } from 'app/shared/layout/menus/menu-components';
import { responsiveFontSizes } from '@mui/material/styles';
import { ThemeProvider } from '@mui/styles';

import { handlePasswordResetInit, reset } from '../account/password-reset/password-reset.reducer';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import { AUTHORITIES } from 'app/config/constants';
import { updateUserLanguage, updateUserLanguageForAllRoles } from 'app/modules/administration/user-management/user-management.reducer';

const useStyles = () => ({
  headerText: {
    margin: '30px 8px 5px 50px',
  },
});

export const BoubyanPasswordResetInit = () => {
  const dispatch = useAppDispatch();
  // Whatever brought us here (e.g. the original SMS-linked quotation, via login.tsx's "Reset password?" link)
  // is kept in location.state and passed straight through to the "back to login" link below.
  const location = useLocation();
  const account = useAppSelector(state => state.authentication.account);
  const user = useAppSelector(state => state.userManagement.user);
  const [resetPasswordEmail, setResetPasswordEmail] = useState('');
  const [openMessageDialog, setOpenMessageDialog] = useState(false);

  useEffect(() => () => {
    dispatch(reset());
  }, []);

  const successMessage = useAppSelector(state => state.passwordReset.successMessage);
  useEffect(() => {
    if (successMessage) {
      toast.success(translate(successMessage));
    }
  }, [successMessage]);

  const getDialogContent = () => <Translate contentKey="reset.request.emailMessages" />;

  const handleValidSubmitEmail = () => {
    dispatch(handlePasswordResetInit(resetPasswordEmail));
    setOpenMessageDialog(true);
  };

  const handleToClose = () => setOpenMessageDialog(false);

  const handleLocaleChange = event => {
    const langKey = event.target.value;
    document.querySelector('html').setAttribute('dir', isRTL(langKey) ? 'rtl' : 'ltr');
    Storage.session.set('locale', langKey);
    dispatch(setLocale(langKey));
    try {
      const updatedUser = { ...user, id: account.id, langKey: event.target.value };
      if (account?.authorities.includes(AUTHORITIES.ADMIN)) {
        dispatch(updateUserLanguage(updatedUser));
      } else {
        dispatch(updateUserLanguageForAllRoles(updatedUser));
      }
    } catch (TypeError) {
      console.warn('Account not defined yet');
    }
  };

  const classes = useStyles();
  let responsiveFont = createTheme();
  responsiveFont = responsiveFontSizes(responsiveFont);

  return (
    <div>
      <Grid container justifyContent="center" className="login-page-boubyan">
        <ThemeProvider theme={responsiveFont}>
          <Grid item xs={12} md={5}>
            <Paper elevation={0}>
              <Row>
                <Col xs={7} md={8}>
                  <Grid container direction="row" style={{ ...classes.headerText, alignItems: 'center' }}>
                    <Grid item>
                      <Box component="img" sx={{ maxWidth: { xs: 120, md: 150 }, mr: { xs: 2 }, ml: { xs: 2, md: 2 }, p: 0 }} alt="logo" src="../content/images/boubyan-logo.png" />
                    </Grid>
                  </Grid>
                </Col>
                <Col xs={4} md={4}>
                  <div className="languageSection">
                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                      <NavDropdown
                        icon="language"
                        name={
                          <div className="locale-icon-login">
                            <TranslateIcon sx={{ fontSize: '24px', marginTop: { md: 0, sm: '16px', xs: '-24px' } }} />
                            <Translate contentKey="global.menu.language" />
                          </div>
                        }
                      >
                        {locales.map(locale => (
                          <DropdownItem key={locale} value={locale} onClick={handleLocaleChange}>
                            {languages[locale].name}
                          </DropdownItem>
                        ))}
                      </NavDropdown>
                    </div>
                  </div>
                </Col>
              </Row>

              <h2 className="loginTitle">
                <Translate contentKey="reset.request.title" />
              </h2>

              <Box sx={{ paddingLeft: { xs: '15px', sm: '45px' }, paddingRight: { xs: '15px', sm: '45px' }, marginBottom: '30px' }}>
                <Alert color="warning" className="custom-alert">
                  <Translate contentKey="reset.request.messages.info">Enter the email address you used to register</Translate>
                </Alert>

                <Grid container direction="column">
                  <ValidatedForm onSubmit={handleValidSubmitEmail}>
                    <ValidatedField
                      name="email"
                      value={resetPasswordEmail}
                      onChange={e => setResetPasswordEmail(e.target.value)}
                      placeholder={translate('global.form.email.placeholder')}
                      id="email"
                      style={{ textAlign: Storage.session.get('locale') === 'en' ? 'left' : 'right', width: '100%' }}
                      sx={{ mb: 3 }}
                      type="email"
                      validate={{
                        required: { value: true, message: translate('global.messages.validate.email.required') },
                        minLength: { value: 5, message: translate('global.messages.validate.email.minlength') },
                        maxLength: { value: 254, message: translate('global.messages.validate.email.maxlength') },
                        pattern: {
                          value: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                          message: translate('global.messages.validate.email.invalid'),
                        },
                      }}
                    />
                    <Button className="mt-2" variant="contained" size="medium" color="primary" type="submit" data-cy="submit" fullWidth>
                      <Translate contentKey="reset.request.form.button">Reset password</Translate>
                    </Button>
                  </ValidatedForm>
                </Grid>

                <div id="backToLogin" className="mt-3" style={{ textAlign: 'center' }}>
                  <Link to={{ pathname: "/boubyan/login", state: location.state }} style={{ fontWeight: 'normal' }}>
                    <Translate contentKey="reset.request.backBtn" />
                  </Link>
                </div>
              </Box>
            </Paper>
          </Grid>
        </ThemeProvider>
      </Grid>

      <Dialog open={openMessageDialog} onClose={handleToClose}>
        <DialogTitle />
        <DialogContent>
          <DialogContentText style={{ color: 'black' }} className="mb-3">
            {getDialogContent()}
          </DialogContentText>
        </DialogContent>
        <DialogActions className="mx-3">
          <DialogContentText>
            <ButtonReact color="primary" onClick={handleToClose} autoFocus>
              {translate('comexApp.quotation.okButton')}
            </ButtonReact>
          </DialogContentText>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default BoubyanPasswordResetInit;
